var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.$router.history.current.path != '/login')?_c('c-header'):_vm._e(),_c('c-loader',{attrs:{"loaderFlag":_vm.loaderFlag}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }